const Rights = {
    vehicle: {
        read: "veh:read",
        write: "veh:write",
        create: "veh:create",
        delete: "veh:delete",
        noteCreate: "veh:note:create",
        noteDelete: "veh:note:delete",
    }
};

export default Rights;
